import { Capacitor } from "@capacitor/core"

export type StoreId = "google-play" | "rustore" | "app-store"

let cached: StoreId | null | undefined

export function detectStore(): StoreId | null {
	if (cached !== undefined) return cached

	if (typeof window === "undefined" || !Capacitor.isNativePlatform()) {
		cached = null
		return cached
	}

	if (Capacitor.getPlatform() === "ios") {
		cached = "app-store"
		return cached
	}

	if (Capacitor.isPluginAvailable("RuStorePay")) cached = "rustore"
	else cached = "google-play"
	return cached
}
